import React from 'react'
import styled from 'styled-components'
import { FundingSource } from '../../types'
import { SubGroupLabel, TableCell, TableHeader } from '../components'

const HiddenTableCell = styled(TableCell)`
  visibility: hidden;
`

interface Props {
  fundingSources: FundingSource[]
}

export const FundingSourcesList: React.FC<Props> = ({ fundingSources }) => (
  <>
    <SubGroupLabel>Funding Sources</SubGroupLabel>
    <table>
      <tbody>
        <tr>
          <TableHeader>Funding Source</TableHeader>
          <TableHeader>Status</TableHeader>
          <TableHeader>Last 4</TableHeader>
          <TableHeader>Network</TableHeader>
        </tr>
        {fundingSources.map((source: FundingSource, i) => {
          return (
            <tr key={source.id}>
              <TableCell>{`Funding Source ${i + 1}`}</TableCell>
              <TableCell>{source.state}</TableCell>
              <TableCell>{source.last4}</TableCell>
              <TableCell>{source.network}</TableCell>
              {/* Hidden 'Details' cell provides an exact spacing match with the VirtualCardsList */}
              <HiddenTableCell>Details</HiddenTableCell>
            </tr>
          )
        })}
      </tbody>
    </table>
  </>
)
